import styled from 'styled-components/native'

export const Container = styled.View`
  position: absolute;
  bottom: ${({ theme }) => theme.space[2]}px;
  right: ${({ theme }) => theme.space[2]}px;
  z-index: 100;
  justify-content: center;
  align-items: center;
`

export const TagButton = styled.TouchableOpacity`
  height: 30px;
  background-color: ${({ theme }) => theme.colors.secondary2};
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.space[2]}px;
  border-radius: 4px;
  opacity: 0.8;
  cursor: pointer;
`

export const Tag = styled.Text`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
`

export const DropdownContainer = styled.View`
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: ${({ theme }) => theme.space[1]}px;
  width: 100%;
  opacity: 0.9;
  overflow: hidden;
`

export const DropdownItem = styled.TouchableOpacity`
  flex-direction: row;
  padding: ${({ theme }) => theme.space[2]}px;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const DropdownText = styled.Text`
  font-size: 16px;
  font-weight: 500;
  color: #000;
`
